<p-dialog
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [visible]="isVisible"
  [draggable]="false"
  [classList]="'filter_dialog trip-actions-dialog'"
  [position]="'right'"
  [resizable]="false"
  [closable]="false"
  [style]="{'top': 'auto', 'bottom': '0px'}">

  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
      <p>ACTIONS</p>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <p-scrollPanel [className]="'filter_scrollPanel'">
    <!-- Trip Details Header -->
    <div *ngIf="tripActionsData" class="trip-header mb-3 p-3">
      <!-- First row - Requested dates -->
      <div class="flex justify-content-between align-items-center mb-3 trip-row">
        <div class="trip-info">
          <h6 class="mb-1 fw-500 text-dark">Requested Pick-up</h6>
          <p class="fs-12 text-muted">{{ tripActionsData.pickup_at?tripActionsData.pickup_at : '-' }}</p>
        </div>
        <div class="vertical-divider"></div>
        <div class="trip-info text-right">
          <h6 class="mb-1 fw-500 text-dark">Requested Delivery</h6>
          <p class="fs-12 text-muted">{{ tripActionsData.delivered_at?tripActionsData.delivered_at : '-' }}</p>
        </div>
      </div>

      <!-- Second row - Actual dates -->
      <div class="flex justify-content-between align-items-center trip-row">
        <div class="trip-info">
          <h6 class="mb-1 fw-500 text-dark">Actual Pick-up</h6>
          <p class="fs-12 text-muted">{{tripActionsData.actual_pickup_datetime?tripActionsData.actual_pickup_datetime : '-'}}</p>
        </div>
        <div class="vertical-divider"></div>
        <div class="trip-info text-right">
          <h6 class="mb-1 fw-500 text-dark">Actual Delivery</h6>
          <p class="fs-12 text-muted"> {{ tripActionsData?.actual_delivery_datetime ? tripActionsData.actual_delivery_datetime : '-' }}</p>
        </div>
      </div>
    </div>

    <!-- Actions Timeline -->
    <p-timeline [value]="timelineData" class="w-full md:w-20rem">
      <ng-template pTemplate="marker" let-action>
        <div class="custom-timeline-marker" [ngClass]="{'completed': action.isCompleted, 'pending': !action.isCompleted}">
          <span class="action-number">{{ action.actionNumber }}</span>
        </div>
      </ng-template>

      <ng-template pTemplate="content" let-action>
        <div class="flex flex-row justify-content-between text-sm">
          <h5 class="font-poppin fw-500 action-title">
            {{ action.name }}
          </h5>
          <div *ngIf="action.showPod" class="action-pod">
            <a href="javascript:void(0)"
               class="pod-link fs-12 fw-500 font-poppin"
               (click)="onPodClick(action)">
              View POD
            </a>
          </div>
        </div>
        <div class="action-date fs-12 text-color-grey4 font-poppin">
          {{ action.date }}
        </div>
      </ng-template>
    </p-timeline>

    <!-- Empty State -->
    <div *ngIf="timelineData.length === 0" class="text-center p-4">
      <i class="pi pi-info-circle" style="font-size: 3rem; color: #ccc;"></i>
      <p class="mt-2 text-600">No actions found for this trip.</p>
    </div>
  </p-scrollPanel>
</p-dialog>
